import { Calendar, Clock, Activity, CheckCircle } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetDashboardData } from "../../../hooks";

const SchedulesDashboard = () => {
  const { data: dashboardData } = useGetDashboardData();

  const metricsData = [
    {
      title: "Total Active Schedules",
      count: dashboardData?.totalActiveSchedules?.value || 0,
      trendSummary: "Currently active",
      icon: <Calendar className="h-8 w-8 text-blue-500" />,
      tooltip: "Number of currently active preventive maintenance or inspection schedules in the system.",
    },
    {
      title: "Schedules Due (Next 7 Days)",
      count: dashboardData?.schedulesDueNext7Days?.value || 0,
      trendSummary: "Upcoming tasks",
      icon: <Clock className="h-8 w-8 text-orange-500" />,
      tooltip: "Total tasks scheduled for completion within the next 7 days.",
    },
    {
      title: "Overdue Schedules",
      count: dashboardData?.overdueSchedules?.value || 0,
      trendSummary: "Need attention",
      icon: <Activity className="h-8 w-8 text-red-500" />,
      tooltip: "Number of schedules that have missed their planned completion date and need urgent attention.",
    },
    {
      title: "Completion Rate (Last 30 Days)",
      count: dashboardData?.completionRateLast30Days?.value || 0,
      trendSummary: "Overall performance",
      icon: <CheckCircle className="h-8 w-8 text-green-500" />,
      suffix: "%",
      tooltip: "Percentage of scheduled tasks successfully completed out of the total due in the last 30 days.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metricsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};

export default SchedulesDashboard;
